/**
 * Reference type badge per F-FE-CORPUS-BROWSER §3.2 Tab 5 (Luoc do).
 *
 * 11 verified refType labels (~99.5% edges) + "Khác" group for LOW codes
 * 8/13/14. Color mapping locked in lib/corpus-api refTypeLabel().
 *
 * Hallucinated label or hardcoded < 11 codes = data-quality HARD VETO.
 */

import { refTypeLabel } from '../../lib/corpus-api';

export function RefTypeBadge({ code }: { code: number }) {
  const { label, color } = refTypeLabel(code);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '3px 10px',
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 600,
        background: `${color}1a`,
        color,
        border: `1px solid ${color}33`,
        fontFamily: 'var(--font-sans)',
        whiteSpace: 'nowrap',
      }}
      title={label}
    >
      <span
        aria-hidden
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: color,
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
}
